jQuery(document).ready(function( $ ) {

	$(document).ready(function() {
		nskShareFunction();
	});

	function nskShareFunction() {
		const shareButton = $('.js-share-link');

		shareButton.on('click', function() {
			let title = $(this).data('share-title');
			let url = $(this).data('share-url');
			let text = $(this).data('share-text');

			if (navigator.share) {
				navigator.share({
					title: title,
					url: url,
					text: text,
				}).then(() => {
					console.log('Thanks for sharing!');
				})
				.catch(console.error);
			} else {
				const width   = 981;
				const height  = 461;
				const left    = (screen.width / 2) - (width / 2);
				const top     = (screen.height / 2) - (height / 2);
				$('.js-share-link').click(function(e) {
					e.preventDefault();
					window.open(
					$(this).attr('href'),
					'',
					'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=' + width + ',height=' + height + ',top=' + top + ',left=' + left
					);
				});
			}
		});
	}


});